export default __webpack_public_path__ + "static/media/5-2.d1bf6cd5.png";